import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Instagram } from 'lucide-react';
import NewsletterForm from './NewsletterForm';

const Footer = () => {
  return (
    <footer className="bg-[#1A2238] text-white py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold mb-4 text-[#00D2D3]">Vocavi Partners</h3>
            <p className="text-slate-300 mb-4">
              Leading executive search firm specializing in C-suite and senior leadership recruitment across key industries.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#00D2D3]">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-slate-300 hover:text-secondary transition-colors" data-testid="footer-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/sectors" className="text-slate-300 hover:text-secondary transition-colors" data-testid="footer-sectors">
                  Sectors
                </Link>
              </li>
              <li>
                <Link to="/jobs" className="text-slate-300 hover:text-secondary transition-colors" data-testid="footer-jobs">
                  Open Positions
                </Link>
              </li>
              <li>
                <Link to="/methodology" className="text-slate-300 hover:text-secondary transition-colors" data-testid="footer-methodology">
                  Our Methodology
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#00D2D3]">Sectors</h4>
            <ul className="space-y-2 text-slate-300">
              <li>Manufacturing</li>
              <li>Engineering</li>
              <li>Automation</li>
              <li>Fashion & Apparel</li>
              <li>Energy</li>
              <li>Emerging Technology</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-[#00D2D3]">Contact</h4>
            <div className="space-y-3 text-slate-300">
              <div className="flex items-start" data-testid="footer-location">
                <MapPin size={18} className="mr-2 mt-1 flex-shrink-0" />
                <span>Gurugram, India</span>
              </div>
              <div className="flex items-center" data-testid="footer-phone">
                <Phone size={18} className="mr-2 flex-shrink-0" />
                <a href="tel:+917827644781" className="hover:text-secondary transition-colors">
                  +91 7827644781
                </a>
              </div>
              <div className="flex items-center" data-testid="footer-email">
                <Mail size={18} className="mr-2 flex-shrink-0" />
                <a href="mailto:connect@vocavi.in" className="hover:text-secondary transition-colors">
                  connect@vocavi.in
                </a>
              </div>
              <div className="flex items-center space-x-4 mt-4">
                <a 
                  href="https://www.linkedin.com/company/vocavi-partners-llp/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-secondary transition-colors" 
                  data-testid="footer-linkedin"
                  aria-label="LinkedIn"
                >
                  <Linkedin size={20} />
                </a>
                <a 
                  href="https://www.instagram.com/vocavipartners" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-secondary transition-colors" 
                  data-testid="footer-instagram"
                  aria-label="Instagram"
                >
                  <Instagram size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-700 pt-10 mb-10" data-testid="footer-newsletter">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h4 className="text-lg font-semibold mb-2 text-[#00D2D3]">Leadership Hiring Insights</h4>
              <p className="text-slate-300 text-sm">
                Monthly perspectives on executive search, leadership trends, and talent strategy. No spam, unsubscribe anytime.
              </p>
            </div>
            <NewsletterForm source="footer" variant="dark" testId="footer-newsletter-form" />
          </div>
        </div>

        <div className="border-t border-slate-700 pt-8 text-center text-slate-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Vocavi Partners LLP. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;